import posthog from 'posthog-js'
import { defaultConfig } from '@/config'
import { readDisplayProperties } from '@/lib/analytics/displayProperties'

const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || '/ingest'

let posthogInitialized = false

export function initPostHog(): void {
  if (posthogInitialized) return
  const cfg = defaultConfig()
  if (cfg.envMode !== 'production') return

  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) return

  posthog.init(key, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
  })
  // Un changement de zoom déclenche resize : les événements suivants portent la nouvelle valeur.
  const registerDisplayProperties = () =>
    posthog.register({ ...readDisplayProperties() })
  registerDisplayProperties()
  window.addEventListener('resize', registerDisplayProperties)
  posthogInitialized = true
}

export function isPostHogEnabled(): boolean {
  const cfg = defaultConfig()
  return (
    cfg.envMode === 'production' && Boolean(import.meta.env.VITE_POSTHOG_KEY)
  )
}

export { posthog }
